import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Shell } from '@/components/layout/Shell';
import { AuthGate } from '@/AuthGate';
import Cockpit from '@/pages/Cockpit';
import Dashboard from '@/pages/Dashboard';
import ReportBuilder from '@/pages/ReportBuilder';
import HangMonitor from '@/pages/HangMonitor';
import MakeupSource from '@/pages/MakeupSource';
import Utilities from '@/pages/Utilities';
import AlarmCenter from '@/pages/AlarmCenter';
import Production from '@/pages/Production';
import Recipes from '@/pages/Recipes';
import AiResearch from '@/pages/AiResearch';
import ComplianceExport from '@/pages/ComplianceExport';
import LabLoop from '@/pages/LabLoop';
import Equipment from '@/pages/Equipment';
import AppPreview from '@/pages/AppPreview';
import WorkOrders from '@/pages/WorkOrders';
import Users from '@/pages/Users';
import Login from '@/pages/Login';
import '@/styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1, staleTime: 2000 },
  },
});

const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    element: (
      <AuthGate>
        <Shell />
      </AuthGate>
    ),
    children: [
      { index: true, element: <Cockpit /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'report', element: <ReportBuilder /> },
      { path: 'hang', element: <HangMonitor /> },
      { path: 'makeup', element: <MakeupSource /> },
      { path: 'utilities', element: <Utilities /> },
      { path: 'alarms', element: <AlarmCenter /> },
      { path: 'production', element: <Production /> },
      { path: 'recipes', element: <Recipes /> },
      { path: 'ai', element: <AiResearch /> },
      { path: 'compliance', element: <ComplianceExport /> },
      { path: 'lab', element: <LabLoop /> },
      { path: 'equipment', element: <Equipment /> },
      { path: 'app', element: <AppPreview /> },
      { path: 'work-orders', element: <WorkOrders /> },
      { path: 'admin/users', element: <Users /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
